import { colors } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { red, blue, yellow } from '@mui/material/colors';
import shadows from './shadows';
import typography from './typography';
import MarsFontArray from './marsFont';
// import MarsCentraBold from '../fonts/MarsCentra-Bold.woff2'
// import MarsCentraExtrabold from '../fonts/MarsCentra-Extrabold.woff2'

// const MarsCentraWeb = {
//   fontFamily: 'MarsCentra-Book',
//   fontStyle: 'normal',
//   fontDisplay: 'swap',
//   fontWeight: 'normal',
//   src: `url("../fonts/MarsCentra-Book.woff2") format("woff")`
// };

// Normal or default theme
const theme = createTheme({
  palette: {
    type: 'light',
    background: {
      default: '#F4F6F8',
      paper: colors.common.white,
      progressBar: blue[500]
    },
    primary: {
      // light: will be calculated from palette.primary.background,
      main: '#0000A0',
      background: '#FFFFFF',
      contrastText: 'white',
      textColor: 'rgba(0, 0, 0, 0.87)',
      sideMenuTextColor: '#8F8F8F',
      sideMenuTitleColor: '#212121'
      // contrastText: 'rgba(0, 0, 0, 0.87)'
      // dark: will be calculated from palette.primary.background,
      // contrastText: will be calculated to contrast with palette.primary.background
    },
    secondary: {
      light: '#0066ff',
      main: '#e0e0e0',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00'
    },
    // Provide every color token (light, main, dark, and contrastText) when using
    // custom colors for props in Material UI's components.
    // Then you will be able to use it like this: `<Button color="custom">`
    // (For TypeScript, you need to add module augmentation for the `custom` value)
    //   custom: {
    //     light: '#ffa726'
    //     main: '#f57c00',
    //     dark: '#ef6c00',
    //     contrastText: 'rgba(0, 0, 0, 0.87)',
    //   }
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
    // primary: {
    //   main: '#FFFFFF',
    //   contrastText: 'rgba(0, 0, 0, 0.87)',
    // },
    // secondary: {
    //   main: '#e0e0e0',
    //   contrastText: 'rgba(0, 0, 0, 0.87)',
    // },
    error: {
      main: red['A400']
    },
    titleBar: {
      main: '#eeeeee',
      contrastText: '#222222'
    }
  },
  shadows,
  typography,
  components: {
    MuiCssBaseline: {
      styleOverrides: [...MarsFontArray]
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '12px'
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: '12px',
          textTransform: 'none',
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            fontSize: '12px'
          },
          '&.Mui-selected:hover': {
            backgroundColor: theme.palette.primary.main
          }
        })
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: '10px'
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          fontSize: '12px',
          paddingTop: '5px',
          paddingBottom: '5px'
        }
      }
    }
  }
});

export default theme;
